const faqEn = {
    title: 'FAQ',
    actions: {
        contact: 'Contact us',
        readMore: 'Read more',
    },
    sections: {
        about: 'About Mundu',
        terms: 'Definitions',
        guide: 'Guidance',
        account: 'Delete users or end subscription',
    },
    entries: {
        '1': {
            title: 'What is Mundu?',
            content:
                'Research shows that personal music can reduce anxiety, agitation, and depression for people living with dementia while boosting memory and enabling better conversations. When personalised music is combined with meaningful photos, the effect becomes even stronger. That experience is at the heart of Mundu.',
        },
        '2': {
            title: 'What does Mundu mean?',
            content:
                'Mundu is an old Norse word still used in Iceland and relates to memory, as in “Do you remember that time…?”.',
        },
        '3': {
            title: 'How does Mundu work?',
            content:
                'Mundu builds on documented music-therapy research showing that preference-based music can calm, inspire, and strengthen memory. The service gives therapists and care teams a digital tool to create users, invite relatives, and produce videos that combine personal music and photos. Mundu is not a cure for dementia, but it aims to create dignified, meaningful moments throughout the illness.',
        },
        '4': {
            title: 'Who benefits the most from Mundu?',
            content:
                'Mundu focuses on people with mild to moderate dementia, but the principles of music for health can support other mental-health groups as well. If you know someone in another discipline who wants to try Mundu, please contact us.',
        },
        '5': {
            title: 'Who created Mundu?',
            content:
                'Mundu is a Norwegian product that originated at NKS Olaviken, a psychiatric hospital specialising in elderly care. The idea was developed together with Norwegian music-technology entrepreneurs, and the service has been tested and validated with therapists and healthcare professionals.',
        },
        '6': {
            title: 'What is a “user”?',
            content:
                'A user is a resident, patient, home-dwelling person, or day-care visitor living with dementia.',
        },
        '7': {
            title: 'What is a relative?',
            content:
                'A relative is someone with close family ties—or, if no family is available, a trusted person connected to the user.',
        },
        '8': {
            title: 'What is a superuser?',
            content:
                'The superuser manages Mundu for the organisation. They control access, can create or delete users, employees, and relatives, and handle the customer relationship.',
        },
        '9': {
            title: 'What is a employee?',
            content:
                'A employee is the person who works directly with the user.',
        },
        '10': {
            title: 'What is a connection?',
            content:
                'In the web client you create a connection to the user. Once the connection exists you can start producing a video.',
        },
        '11': {
            title: 'What is a video?',
            content:
                'A Mundu video combines the user’s favourite music with photos from their life. After you send the video it is ready to enjoy in the app.',
        },
        '12': {
            title: 'What is the web client?',
            content:
                'The web client is the tool superusers and employees use to create users, map their musical history, invite relatives, and build videos.',
        },
        '14': {
            title: 'How do I get started in Mundu?',
            content:
                'Start by creating a connection to the user. You are guided through adding musical history and inviting relatives, who can then share photos. Mundu notifies you when new photos arrive. Tip: ask relatives to add short captions. When the groundwork is done, click “Create new video” to follow the step-by-step guide.',
        },
        '15': {
            title: 'How do I create a video?',
            content:
                'After signing in, click the “Create new video” icon. The guided process walks you through every step. If anything is unclear, please tell us so we can improve the experience.',
        },
        '16': {
            title: 'Does it take long to make a video?',
            content:
                'Mundu is designed to keep production time low. If you feel the process is taking too long, let us know what slows you down so we can optimise it.',
        },
        '17': {
            title: 'What is the mapping form?',
            content:
                'The musical mapping form helps you capture the user’s musical life history. Fill it out with the user or relatives to build a better musical foundation for future videos.',
        },
        '18': {
            title: 'How many users can I create videos for?',
            content:
                'The number depends on how many licences your organisation has purchased. Contact us if you need more.',
        },
        '19': {
            title: 'How many employees can I invite?',
            content: 'You can invite an unlimited number of employees.',
        },
        '20': {
            title: 'Can the video play without Wi-Fi?',
            content:
                'Yes. After the initial download, the video can play offline for up to 30 days. The tablet must go online again after that period.',
        },
        '21': {
            title: 'What if the tablet has been offline for more than 30 days?',
            content:
                'For rights-reporting reasons the tablet must reconnect to Wi-Fi or mobile data at least every 30 days. After that, reconnect to regain access.',
        },
        '22': {
            title: 'Can multiple users share the same tablet?',
            content:
                'Yes. Each user has separate credentials. Remember to sign out when the session ends to protect privacy.',
        },
        '23': {
            title: 'Do I need to log out before another user signs in?',
            content:
                'Yes. Log out to allow the next user to access the tablet safely.',
        },
        '24': {
            title: 'How does the relatives’ app work?',
            content:
                'When you invite relatives, they receive an email explaining how to get started. They can share digital photos directly to the user’s library via the app (and soon a web portal).',
        },
        '25': {
            title: 'Will I be notified when relatives add photos?',
            content:
                'Yes. We email you automatically when new photos are available.',
        },
        '26': {
            title: 'Do relatives get notified when I share a video?',
            content:
                'Yes. Relatives receive an email when you share a finished video so they can follow progress.',
        },
        '27': {
            title: 'Can I include multiple users when sharing a video?',
            content:
                'Not right now. If you have a use case that does not compromise privacy, please tell us so we can assess it.',
        },
        '28': {
            title: 'Do you provide a stock photo library?',
            content:
                'We only support private photos because testing shows they create better reminiscence effects. Let us know if generic photos would help your workflow.',
        },
        '29': {
            title: 'What if I get an error message?',
            content:
                'Try again. If the issue persists, notify the superuser who granted access. We log all errors and fix them as quickly as possible.',
        },
        '30': {
            title: 'Where does the music come from?',
            content: 'Mundu licenses its catalogue from 7Digital.',
        },
        '31': {
            title: 'Will TONO or other rights holders invoice us separately?',
            content:
                'No. Music usage is included in your Mundu licence. We have agreements with TONO and the rights holders via GRAMO.',
        },
        '32': {
            title: 'Can I connect Mundu to Spotify?',
            content:
                'No, Mundu cannot connect to other streaming services, but the catalogue is comparable and includes Spotify playlists via 7Digital.',
        },
        '33': {
            title: 'Why can’t I find a specific song?',
            content:
                'Mundu covers most available digital music, but some tracks may be missing because our supplier does not have the rights. Double-check the spelling as well.',
        },
        '34': {
            title: 'Can I add video clips instead of photos?',
            content: 'Not yet. Let us know if this is important for you.',
        },
        '35': {
            title: 'Can I control the song order?',
            content:
                'Yes. Drag and drop the songs into the desired order on desktop, or press and hold on a tablet to move them.',
        },
        '36': {
            title: 'Can I control the photo order?',
            content:
                'Yes. Drag and drop the photos, or press and hold on a tablet to rearrange them.',
        },
        '37': {
            title: 'How many photos should I include?',
            content:
                'Mundu suggests a range based on the total song length. The lower range gives about 30 seconds per photo, the upper about 12 seconds.',
        },
        '38': {
            title: 'Can I save a draft?',
            content:
                'Yes. If you need to pause, your progress is saved until you return.',
        },
        '39': {
            title: 'Can relatives share video clips?',
            content:
                'Not at the moment. Please share feedback if this would be helpful.',
        },
        '40': {
            title: 'Can I delete a connection to a user?',
            content:
                'Yes. Superusers can delete connections, for example after a user passes away. All related data is removed from our servers within 90 days.',
        },
        '41': {
            title: 'What happens to videos if I replace a user?',
            content:
                'Due to rights agreements we cannot keep video material for other users. It is deleted from our servers within 90 days.',
        },
        '42': {
            title: 'Do we need more licences when swapping users?',
            content:
                'No. Licences are tied to the number you have purchased, not to specific individuals. You can reassign them freely within that limit.',
        },
        '43': {
            title: 'Can I preview a video before sharing it?',
            content:
                'Yes. You can preview in the final step and make adjustments before sending.',
        },
        '44': {
            title: 'Can I fast-forward on the tablet?',
            content: 'Not yet, but the feature is under development.',
        },
        '45': {
            title: 'Can I pause and resume later?',
            content: 'This is not supported yet, but it is on our roadmap.',
        },
        '46': {
            title: 'Is it safe to send a video?',
            content:
                'Yes. Only the selected recipient can access the video, and they must sign in on the tablet to watch it.',
        },
        '47': {
            title: 'Is privacy protected?',
            content: 'Yes. Mundu complies with applicable privacy regulations.',
        },
        '48': {
            title: 'How do you handle security?',
            content:
                'Mundu uses the necessary technical and organisational measures to keep data safe. Institutions must use two-factor authentication.',
        },
        '49': {
            title: 'Is there a built-in guide?',
            content:
                'Most answers are available on this page. We intentionally skipped a wizard because we believe the service is intuitive, but please tell us if you miss guidance somewhere.',
        },
        '50': {
            title: 'What if the user has no relatives?',
            content:
                'A healthcare worker can act as a relative. Make sure each person uses a unique email address.',
        },
        '51': {
            title: 'Who can delete users?',
            content:
                'Only the superuser can delete employees, users, and relatives.',
        },
        '52': {
            title: 'Can I delete a user?',
            content: 'Only the superuser has that access.',
        },
        '53': {
            title: 'I am a relative and want to delete my profile. How?',
            content:
                'Relatives can delete their profile from the Settings menu in the app.',
        },
        '54': {
            title: 'How do I cancel the subscription?',
            content: 'Please contact us to terminate the subscription.',
        },
    },
};

export default faqEn;
